import 'globals';

(function (window) {
    window.addEventListener('load', function () {
        window.lazyLoadObject = new LazyLoad({
            callback_load: function (el) {
                window.picturefill({
                    reevaluate: true
                });
            }
        });
    });
})(window);
